import ResponseCreate from './ResponseCreate'
import ResponseEdit from './ResponseEdit'

export default {
  create: ResponseCreate,
  edit: ResponseEdit,
}
